<div class="container-tig">
    <div class="title">
        <h4>蒙古文无衬线报体优点和特点</h4>
    </div>
    <div class="cont-item">
        <p>随着计算机作为现代社会中的常用工具，其使用度越来越高，智能手机、平板电脑等各种电子产品 已经成为人们生活、学习、工作不可或缺的必备工具。那么作为信息载体，对信息的传递与交流起 着关键作用的字体来说，在互联网时代的发展进程中它的适用性是否极强，这很重要。
        </p>
        <br>
        <p>为了提高蒙古文字体在互联网时代的适用性，专门设计开发蒙古无衬线报体。那么该字体与其他现 有的蒙古字体相比它的主要特点和优势在于：一是辨识度和可读性高，二是同样的面积里信息含量 大。那么下面分别与蒙古文白体（目前蒙古文字体中不管是印刷还是网络媒体最广泛用的是蒙古文 白体）、蒙古文报体（很多用户误以为无衬线报体和报体是同一个字体）、Noto sans Mongolian （在安卓手机、各种界面设计中广泛使用该字体）来比较举例。
        </p>
    </div>
    <div>
        <div class="td-vs">
            <div class="td-active-1">蒙古文无衬线报体</div>
            <div>
                <img src="/assets/images/td-vs.png" alt="Onon字体 - vs图片">
            </div>
            <div>
                <ul>
                    <li>
                        <div [routerLink]="['/characteristic/VsBt']" routerLinkActive="td-active">蒙古文白体</div>
                    </li>
                    <li>
                        <div [routerLink]="['/characteristic/VsBot']" routerLinkActive="td-active">蒙古文报体</div>
                    </li>
                    <li>
                        <div [routerLink]="['/characteristic/VsNsm']" routerLinkActive="td-active">noto sans Mgonglian</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>